import { Input, InputNumber, Button, Tooltip, Layout, Menu, Tabs, Spin, ConfigProvider, Dropdown, Form, Divider } from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import { App } from 'vue'
import { AntDesignVueCompItem } from '../types'

const antDesignVueComp:AntDesignVueCompItem[] = [
  { name: 'a-form', comp: Form },
  { name: 'a-form-item', comp: Form.Item },
  { name: 'a-input', comp: Input },
  { name: 'a-input-password', comp: Input.Password },
  { name: 'a-input-number', comp: InputNumber },
  { name: 'a-button', comp: Button },
  { name: 'a-tooltip', comp: Tooltip },
  { name: 'a-layout', comp: Layout },
  { name: 'a-layout-header', comp: Layout.Header },
  { name: 'a-layout-sider', comp: Layout.Sider },
  { name: 'a-layout-content', comp: Layout.Content },
  { name: 'a-layout-footer', comp: Layout.Footer },
  { name: 'a-dropdown', comp: Dropdown },
  { name: 'a-menu', comp: Menu },
  { name: 'a-menu-item', comp: Menu.Item },
  { name: 'a-sub-menu', comp: Menu.SubMenu },
  { name: 'a-item-group', comp: Menu.ItemGroup },
  { name: 'a-tabs', comp: Tabs },
  { name: 'a-spin', comp: Spin },
  { name: 'a-divider', comp: Divider },

  { name: 'a-config-provider', comp: ConfigProvider }
]
export default (app: App<Element>) => {
  antDesignVueComp.forEach((item) => {
    app.component(item.name, item.comp)
  })
  return app
}
